class WristBroProduct {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('form[action*="/cart/add"]');
    this.variant = root.querySelector('[data-wb-variant]');
    this.variantInput = root.querySelector('input[name="id"]');
    this.status = root.querySelector('[data-wb-status]');
    this.sticky = document.querySelector('[data-wb-sticky]');
    this.bind();
  }

  bind() {
    this.variant?.addEventListener('change', () => {
      this.variantInput.value = this.variant.value;
      const option = this.variant.selectedOptions[0];
      this.status.textContent = option.dataset.available === 'true' ? 'In stock and ready to ship' : 'Currently unavailable';
      this.form.querySelector('[type="submit"]').disabled = option.dataset.available !== 'true';
      document.dispatchEvent(new CustomEvent('pdp:offer-change', { detail: { variantId: this.variant.value } }));
    });

    this.form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;
      this.status.textContent = 'Adding to cart…';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.variantInput.value), quantity: Number(this.form.quantity.value || 1) }]
          })
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cartItem = await response.json();
        this.status.textContent = 'Added to your cart';
        document.dispatchEvent(new CustomEvent('pdp:cart-success', { detail: cartItem }));
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        this.status.textContent = 'We could not add this item. Please try again.';
        button.disabled = false;
      }
    });

    if (this.sticky && this.form) {
      const observer = new IntersectionObserver(([entry]) => this.sticky.toggleAttribute('data-visible', !entry.isIntersecting));
      observer.observe(this.form);
    }
  }
}

document.querySelectorAll('[data-wb-product-root]').forEach((root) => new WristBroProduct(root));
